<script lang="ts">
  import { Link2 } from 'lucide-svelte';
  import Avatar from '$lib/components/ui/Avatar.svelte';
  import Chip from '$lib/components/ui/Chip.svelte';
  import type { AssignableUser, Task } from '$lib/types';

  const {
    task,
    dragging,
    members,
    onDragStart,
    onDragEnd,
    onClick
  }: {
    task: Task;
    dragging: boolean;
    members: AssignableUser[];
    onDragStart: (e: DragEvent) => void;
    onDragEnd: () => void;
    onClick: () => void;
  } = $props();

  const assignee = $derived(task.assignee_user_id ? members.find((m) => m.id === task.assignee_user_id) : null);
</script>

<div
  class="task {dragging ? 'dragging' : ''}"
  draggable="true"
  ondragstart={onDragStart}
  ondragend={onDragEnd}
  onclick={onClick}
  role="button"
  tabindex="0"
  onkeydown={(e) => e.key === 'Enter' && onClick()}
>
  <div class="task-key">{task.key}</div>
  <div class="task-title">{task.title}</div>
  <div class="task-foot">
    {#if task.tag}<Chip label={task.tag} kind={task.tag === 'bug' ? 'danger' : 'gray'} />{/if}
    {#if task.from_ticket_id}
      <span title="Linked to a ticket" style="display:inline-flex;color:var(--t3)"><Link2 size={14} /></span>
    {/if}
    <span style="flex:1"></span>
    {#if assignee}<Avatar id={assignee.id} name={assignee.name} size={22} />{/if}
  </div>
</div>
